export default __webpack_public_path__ + "static/commerce-2-1c19bf1d9553d7bc6ec84d7019c74492.png";